import React from 'react'
import { Button } from '../ui/button';
import BackBtn from './BackBtn';

interface MainHeadingProps {
    title: string;
    subtitle?: string;
    isBackButtonVisible?: boolean;
    buttonText?: string;
    buttonIcon?: React.ReactNode;
    onClick?: () => void;
}

const MainHeading: React.FC<MainHeadingProps> = ({ title, subtitle, isBackButtonVisible, buttonText, buttonIcon, onClick }) => {
    return (
        <div className='flex justify-between items-center flex-wrap gap-5'>
            <div className='flex items-center gap-3 md:gap-5 flex-wrap'>
                {isBackButtonVisible && <BackBtn />}
                <div className='flex-1'>
                    <div className='space-y-1'>
                        <h1 className="text-xl md:text-2xl lg:text-3xl font-bold text-foreground">{title}</h1>
                        {subtitle && <p className="text-muted-foreground text-sm md:text-base">{subtitle}</p>}
                    </div>
                </div>
            </div>
            {buttonText &&
                <Button
                    variant="default"
                    onClick={onClick}
                    className="group transition-all"
                >
                    {buttonIcon && buttonIcon} {buttonText}
                </Button>}
        </div>

    )
}

export default MainHeading
